
<template>
  <div class="message-box dialog-mask" @click="$close(false)">
    <div class="dialog-content">
      <header>{{ title }}</header>
      <div class="dialog-body">
        <p>{{ content }}</p>
      </div>
      <footer>
        <button class="spl-button spl-button-secondary" @click="$close(false)">
          {{ negativeText }}
        </button>
        <button class="spl-button" @click="$close(true)">
          {{ positiveText }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'content', 'positiveText', 'negativeText']
}
</script>

<style lang="scss">
    @import '../../variables.scss';
    .dialog-mask {
        background-color: rgba(0, 0, 0, 0.5);
        height: 100vh;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 90000;
          overflow: auto;

        &-show {
            display: block;
        }
        .dialog-content {

            left: 50%;
            padding: 30px 25px 15px 25px;
            position: absolute !important;
            top: 25%;
            transform: translate3d(-50%, 0, 0);
            background-color: white;

            header {
              font-weight: 700;
            }

            footer {
              margin-top: 40px;
              .spl-button {
                min-width: 95px;
                margin: 0;
                margin-right: 10px;
              }
            }
        }
    }
</style>
